import React, { createContext, useContext, useState } from "react";

export interface CsrfDetails {
  key: string;
  value: string;
}

export interface Config {
  loaded: boolean;
  uiUrl?: string;
  feedbackApiKey?: string;
  language: string;
  loginRequired?: boolean;
  technicalError?: boolean;
  logoutUrl?: string;
  loginPageUrl?: string;
  csrf?: CsrfDetails;
}

interface ConfigType {
  config: Config;
  restart: () => any;
  setLoginRequired: () => any;
  setTechnicalError: () => any;
  setLanguage: (language: string) => any;
}

const INITIAL_CONFIG: ConfigType = {
  config: { loaded: false, language: "fi" },
  restart: () => "",
  setLoginRequired: () => "",
  setTechnicalError: () => "",
  setLanguage: (language: string) => "",
};

export interface ConfigContextProviderProps {
  windowConfig: any;
  children?: React.ReactNode;
}

export const ConfigContext = createContext<ConfigType>(INITIAL_CONFIG);

export const ConfigContextProvider: React.FC<ConfigContextProviderProps> = ({
  windowConfig,
  children,
}) => {
  const baseConfig = {
    ...windowConfig,
    loaded: true,
    loginRequired: false,
    technicalError: false,
    language: "fi",
  };
  const [config, setConfig] = useState<Config>(baseConfig);

  const setLoginRequired = () => {
    setConfig((prevState: Config) => ({ ...prevState, loginRequired: true }));
  };

  const setTechnicalError = () => {
    setConfig((prevState: Config) => ({ ...prevState, technicalError: true }));
  };

  const setLanguage = (language: string) => {
    setConfig((prevState: Config) => ({ ...prevState, language: language }));
  };

  const restart = async () => {
    setConfig(baseConfig);
  };

  return (
    <ConfigContext.Provider
      value={{
        config,
        restart,
        setLoginRequired,
        setTechnicalError,
        setLanguage,
      }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
